import { FormEvent, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "../auth";
import { Button } from "../ui";

export default function Login() {
  const { token, login, loading } = useAuth();
  const [tok, setTok] = useState("");
  const [err, setErr] = useState<string | null>(null);
  const nav = useNavigate();

  if (token) return <Navigate to="/" replace />;

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setErr(null);
    try {
      await login(tok.trim());
      nav("/");
    } catch (e) {
      setErr((e as Error).message);
    }
  };

  return (
    <div className="h-full flex items-center justify-center bg-surface-2">
      <form
        onSubmit={submit}
        className="bg-surface border border-border shadow-2xl rounded-2xl p-8 w-full max-w-md"
      >
        <div className="flex items-center gap-3 mb-6">
          <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-brand-500 to-brand-700 grid place-items-center text-white font-bold">
            A
          </div>
          <div>
            <div className="font-semibold text-base">bitop Atlas</div>
            <div className="text-xs text-text-2">
              Wissensspeicher · Projekte · Daten
            </div>
          </div>
        </div>
        <label className="block">
          <span className="text-xs font-medium text-text">
            Bearer-Token
          </span>
          <input
            type="password"
            value={tok}
            onChange={(e) => setTok(e.target.value)}
            placeholder="Token einfügen …"
            className="block w-full mt-1 px-3 py-2 rounded-lg border border-border bg-surface focus:outline-none focus:ring-2 focus:ring-brand-500"
            required
            autoFocus
          />
        </label>
        {err && (
          <div className="mt-3 text-sm text-danger bg-danger-soft px-2 py-1.5 rounded-md">
            {err}
          </div>
        )}
        <Button
          type="submit"
          variant="primary"
          size="lg"
          loading={loading}
          className="mt-5 w-full"
        >
          {loading ? "Prüfe …" : "Einloggen"}
        </Button>
      </form>
    </div>
  );
}
